module.exports = __webpack_public_path__ + "img/py.24bd8c87.png";